import Button from "@/components/ui/Button";
import { Sizes } from "@/lib/centra/hooks/useSizes";
import { ProductVariant } from "@/lib/centra/localAtomics";
import { useTranslations } from "next-intl";
import { useMemo } from "react";
import { EasySizeButton } from "./EasySizeButton";
import { createEasySizeConfig } from "./easysize";
import styles from "./index.module.css";

export const SizeGuideButton = ({
  activeVariant,
  productId,
  sizes,
  addToCartId
}: {
  activeVariant?: ProductVariant;
  productId: string;
  sizes: Sizes;
  addToCartId: string;
}) => {
  const t = useTranslations();
  const config = useMemo(() => {
    return createEasySizeConfig({ activeVariant, productId, addToCartId });
  }, [activeVariant, productId, addToCartId]);

  if (!activeVariant || !config)
    return (
      <Button mode="link" className={styles.sizeguide}>
        <span className={styles.sizeLabel}>{t("sizeguide.title")}</span>
      </Button>
    );

  return <EasySizeButton sizes={sizes} config={config} />;
};
